<template>
  <div>
    <HeaderComponent/>
    <section class="about">
      <div class="container">
        <div class="section-title">
          <h2>About Us</h2>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 about-content">
            <p>Wintel Limited is the first mobile value added service provider in Bangladesh , and has a lion share in the market. We are operating with all mobile operators in the country, namely; GrameenPhone, Robi/Airtel, TeleTalk & Banglalink and also with all the major telecom operators in Middle East Region, Malaysia, Pakistan, Italy, UK and Canada. We have been the first mover to introduce innovative services such as PSMS billing, A2P (Application 2 person) international messaging, mobile app store, telco based mobile wallet, cross-border airtime service and much more. Our decades of dedicated hard work and with collaborative team efforts we have achieved both local and global recognitions, and have a successful footprint in south-east Asia and Mena region. We can proudly say we have an enriched content bank with both local and global contents from all over the globe with our third-party partners. At present, we are working to expand our product portfolio with latest technologies such as DCB (Direct Carrier Billing), Mobile Identify (MI), alternative payment solutions enabled services, rich communication services, smart cloud based call center service , Over-the-top (OTT) streaming platform, lifestyle service apps and more. Our team is constantly working to adapt and remain neck-to-neck with the rapidly moving technology, and our mission is to sustain and keep growing with time.</p>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 image">
            <img src="assets/img/20years.jpg" alt="20years">
          </div>
        </div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import FooterComponent from '@/components/Footer.vue';
export default {
  name: "About",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  computed: {
    getUser() {
      return this.$store.state.authUser
    }
  }
}
</script>

<style scoped>
.about {
  margin-top: 50px;
}
.about-content {
  text-align: justify;
}
.image {
  text-align: center;
}
.image img {
  width: 100%;
  height: 500px;
}
</style>